<mat-card>
  <mat-card-title>Upload accessory PDF</mat-card-title>


  <mat-radio-group [formControl]="identifierControl">
    @for (opt of identifierOptions; track opt) {
      <mat-radio-button [value]="opt.key">
        {{ opt.label }}:
        <code>
          {{ selectedUuidByControl(opt.key) }}
        </code>
      </mat-radio-button>
    }
  </mat-radio-group>

  <div class="drop-zone" [class.dragging]="isDragging" (dragover)="onDragOver($event)" (dragleave)="onDragLeave()"
    (drop)="onDrop($event)">
    @if (!file) {
      <p>Drag & drop PDF here</p>
    }
    @if (file) {
      <p>{{ file.name }}</p>
    }
  </div>

  <button mat-raised-button color="primary" (click)="upload()" [disabled]="!file || !accessoryUuid || isUploading">
    Upload
  </button>
  <button mat-raised-button color="accent" (click)="viewPdf($event)" [disabled]="!accessoryUuid || isUploading">
    View PDF
  </button>

  @if (isUploading) {
    <mat-progress-spinner diameter="32" mode="indeterminate" />
  }
</mat-card>